import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { useMemo } from 'react';
import { colors as accessibleColors } from './accessible/colors.js';
import { containerQueriesToFactory } from './utils/containerQueriesToFactory.js';
import { containerQueriesUpToFactory } from './utils/containerQueriesUpToFactory.js';
import { respondToFactory } from './utils/respondToFactory.js';
import { respondUpToFactory } from './utils/respondUpToFactory.js';
import { spacingFactory } from './utils/spacingFactory.js';
import { typographyFactory } from './utils/typographyFactory.js';
export const ThemeProvider = ({
  children,
  themeTokens,
  isAccessibleTheme = false
}) => {
  const finalTheme = useMemo(() => ({
    ...themeTokens,
    spacing: spacingFactory(themeTokens.spacingTokens, themeTokens.breakpoints.lg),
    typography: typographyFactory(themeTokens.typographyTokens, themeTokens.breakpoints.md, themeTokens.breakpoints.lg),
    respondTo: respondToFactory(themeTokens.breakpoints),
    respondUpTo: respondUpToFactory(themeTokens.breakpoints),
    containerQueriesTo: containerQueriesToFactory(themeTokens.breakpoints),
    containerQueriesUpTo: containerQueriesUpToFactory(themeTokens.breakpoints),
    colors: isAccessibleTheme ? {
      ...themeTokens.colors,
      ...accessibleColors
    } : themeTokens.colors,
    isAccessibleTheme
  }), [themeTokens, isAccessibleTheme]);
  return _jsx(EmotionThemeProvider, {
    theme: finalTheme,
    children: children
  });
};